import React from 'react';
import { Edit2, Trash2, Mail, Phone } from 'lucide-react';
import { updateDoc, doc } from 'firebase/firestore';
import { db } from '../../../firebase';

const HRContactCard = ({ contact, onEdit, onDelete }) => {
    // Toggle verified status directly from the card
    const handleToggleVerified = async () => {
        await updateDoc(doc(db, 'hrContacts', contact.id), { verified: !contact.verified });
    };

    return (
        <div className="flex flex-col gap-2 bg-gradient-to-br from-[#e0f2fe] to-[#f8fafc] rounded-2xl shadow-xl p-3 hover:shadow-2xl transition-shadow duration-300 animate-fadeIn min-w-[220px] w-full max-w-xs sm:max-w-sm md:min-w-[260px]">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                <span className="font-bold text-base sm:text-lg text-gray-900 truncate drop-shadow">{contact.fullName}</span>
                <div className="flex gap-2 self-end sm:self-auto">
                    <button
                        className="p-2 rounded-full hover:bg-[#0071bd] hover:bg-opacity-10 transition-colors"
                        onClick={() => onEdit(contact)}
                        aria-label="Edit"
                    >
                        <Edit2 className="w-5 h-5 text-[#0071bd]" />
                    </button>
                    <button
                        className="p-2 rounded-full hover:bg-red-100 transition-colors"
                        onClick={() => onDelete(contact)}
                        aria-label="Delete"
                    >
                        <Trash2 className="w-5 h-5 text-red-500" />
                    </button>
                </div>
            </div>
            <div className="flex flex-wrap gap-2 items-center mt-1">
                <span className="text-xs sm:text-sm text-gray-600 font-medium bg-white rounded px-2 py-1 shadow-sm">{contact.companyName}</span>
                <a
                    href={`tel:${contact.mobileNo}`}
                    className="flex items-center gap-1 text-xs sm:text-sm text-[#0071bd] font-medium bg-white rounded px-2 py-1 shadow-sm hover:underline"
                    title="Call Mobile"
                >
                    <Phone className="w-4 h-4 text-[#0071bd]" />
                    {contact.mobileNo}
                </a>
                {contact.emailId && (
                    <a
                        href={`mailto:${contact.emailId}`}
                        className="flex items-center gap-1 text-xs text-[#0071bd] font-medium bg-white rounded px-2 py-1 shadow-sm hover:underline"
                        title="Send Email"
                    >
                        <Mail className="w-4 h-4 text-[#0071bd]" />
                        {contact.emailId}
                    </a>
                )}
            </div>
            <div className="flex items-center gap-3 mt-2">
                <span className="text-xs font-semibold text-gray-700">Is Contacted</span>
                <label className="relative inline-flex items-center cursor-pointer select-none">
                    <input
                        type="checkbox"
                        name="verified"
                        checked={contact.verified}
                        onChange={async (e) => {
                            await updateDoc(doc(db, 'hrContacts', contact.id), { verified: e.target.checked });
                        }}
                        className="sr-only peer"
                    />
                    <div className="w-14 h-8 bg-gray-300 rounded-full shadow-inner"></div>
                    <div
                        className={`absolute left-0.5 top-0.5 w-6 h-6 rounded-full transition-transform duration-200 ease-in-out ${contact.verified ? "translate-x-full bg-[#0071bd]" : "bg-gray-500"
                            }`}
                    ></div>
                </label>
            </div>
            <div className="mt-2 sm:mt-3">
                <div className="bg-[#e0f2fe] border border-[#b6e0fe] rounded-lg px-2 py-2 text-xs text-[#0071bd] font-medium shadow-sm min-h-[28px] sm:min-h-[32px]">
                    {contact.note && contact.note.trim() !== '' ? (
                        <span className="whitespace-pre-line">{contact.note}</span>
                    ) : (
                        null
                    )}
                </div>
            </div>
        </div>
    );
};

export default HRContactCard;
